export type CategorySource = "manual" | "system" | "basiq" | "fiskil" | "plaid";
export enum CategorySourceEnum {
  manual = "manual",
  system = "system",
  basiq = "basiq",
  fiskil = "fiskil",
  plaid = "plaid",
}
